import Modal from 'antd/lib/modal/Modal'
import { useDispatch } from 'react-redux'
import { ExclamationCircleOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Button from '~/core/Button'
import { openChatGetPremiumEnabled } from '~/redux-modules/drift'
import getColor from '~/lib/getColor'
import Text from '~/core/Text'

type PremiumTrialExpiredModalType = {
    isPremiumTrialExpiredModalVisible: boolean
    setPremiumTrialExpiredModalVisible: (
        setPremiumTrialExpiredModalVisibility: boolean,
    ) => void
}

function PremiumTrialExpiredModal(props: PremiumTrialExpiredModalType) {
    const {
        isPremiumTrialExpiredModalVisible,
        setPremiumTrialExpiredModalVisible,
    } = props
    const dispatch = useDispatch()

    return (
        <Modal
            visible={isPremiumTrialExpiredModalVisible}
            closable={false}
            footer={
                <Box justifyContent="end" borderTop="0px">
                    <Button
                        onClick={() =>
                            setPremiumTrialExpiredModalVisible(false)
                        }
                    >
                        Return to My quotes &amp; orders
                    </Button>
                    <Button
                        type="primary"
                        onClick={(evt: Event) => {
                            evt.preventDefault()
                            dispatch(openChatGetPremiumEnabled())
                            setPremiumTrialExpiredModalVisible(false)
                        }}
                    >
                        Request upgrade
                    </Button>
                </Box>
            }
        >
            <Box direction="row">
                <Box>
                    <ExclamationCircleOutlined
                        style={{
                            color: getColor('error'),
                            fontSize: '21px',
                        }}
                    />
                </Box>
                <Box
                    style={{ fontSize: '16px' }}
                    alignItems="start"
                    direction="col"
                    width="432px"
                    paddingLeft="16px"
                >
                    <Text
                        fontSize="16px"
                        fontWeight={500}
                        style={{ marginBottom: '8px' }}
                        color="blackAlpha65"
                    >
                        You've lost access to Fictiv Premium
                    </Text>
                    <Text fontSize="14px" color="blackAlpha65" fontWeight={300}>
                        Your team’s quotes &amp; orders have been saved, but
                        you’ll need to upgrade to Premium to regain access to
                        this team workspace. To connect with our team, request
                        an upgrade below.
                    </Text>
                </Box>
            </Box>
        </Modal>
    )
}

export default PremiumTrialExpiredModal
